export var getPrecedence = function (op) {
    if (op === '+' || op === '-') {
        return 2;
    }
    else {
        return 1;
    }
};
